import React, {useState, useEffect} from 'react';
import {TextInput, SelectInput, DateInput, RadioInput, FieldContainer, UrlUtil} from "@graffer-inc/graffer-ui";
import {Link} from "react-router-dom";

const isNotEmpty = v =>  v && v.length > 0;

const Main = ({onSubmit, initialFormData, isRequesting, isEdit}) => {
  const { to } = UrlUtil.parseQueryOf(window.location.search);
  const [formData, setFormData] = useState({
    name: '',
    birthday: {
      year: '',
      month: '',
      day: '',
    },
    qualification: '',
    otherQualification: '',
    typeOfCalendar: '西暦',
  });

  useEffect(() => {
    if (initialFormData) setFormData(initialFormData);
  }, [initialFormData]);

  const isAllValid = () => (
    isNotEmpty(formData.name) 
    && isNotEmpty(formData.qualification)
    && isNotEmpty(formData.birthday.year)
    && isNotEmpty(formData.birthday.month)
    && isNotEmpty(formData.birthday.day))
    && (formData.qualification === 'その他' ? isNotEmpty(formData.otherQualification) : true);
  
  return (
    <div className="columns is-multiline">
      <div className="column is-12">
        <FieldContainer name="印鑑提出者名">
          <TextInput
            value={formData.name}
            placeholder="山田太郎"
            onChange={v => setFormData(
              (f) => {
                f.name = v;
                return Object.assign({}, f);
              })}
            errorMessage="印鑑提出者名を入力してください"
            validate={isNotEmpty}
          />
        </FieldContainer>
      </div>
      <div className="column is-12">
        <FieldContainer name="印鑑提出者資格">
          <div>
            <div className="columns">
              <div className="column">
                <SelectInput
                  value={formData.qualification}
                  onChange={v => setFormData(
                    (f) => {
                      f.qualification = v;
                      return Object.assign({}, f);
                    })}
                  options={[
                    { value: '', name: '選択してください' },
                    { value: '代表取締役', name: '代表取締役' },
                    { value: '取締役', name: '取締役' },
                    { value: '代表理事', name: '代表理事' },
                    { value: 'その他', name: 'その他' },
                  ]}
                  validate={isNotEmpty}
                  errorMessage="印鑑提出者資格を選択してください"
                />
              </div>
              {formData.qualification === 'その他' && (
                <div className="column">
                  <TextInput
                    value={formData.otherQualification}
                    placeholder="代表社員など"
                    onChange={v => setFormData(
                      (f) => {
                        f.otherQualification = v;
                        return Object.assign({}, f);
                      })}
                    validate={isNotEmpty}
                    errorMessage="詳細を入力してください"
                  />
                </div>
              )}
            </div>
          </div>
        </FieldContainer>
      </div>
      <div className="column is-12">
        <FieldContainer name="印鑑提出者生年月日">
          <DateInput
            required
            value={formData.birthday}
            onChange={v => setFormData(
              (f) => {
                f.birthday = v;
                return Object.assign({}, f);
              })}
          />
        </FieldContainer>
      </div>
      <div className="column is-12">
        <FieldContainer name="届出時の生年月日の暦">
          <RadioInput
            value={formData.typeOfCalendar}
            options={[
              { value: '西暦', name: '西暦' },
              { value: '和暦', name: '和暦' },
            ]}
            onChange={v => setFormData(
              (f) => {
                f.typeOfCalendar = v;
                return Object.assign({}, f);
              })}
          />
        </FieldContainer>
      </div>
      <div className="column is-12">
        {
          isEdit ? (
            <div className="is-flex">
              <button
                className={`button has-text-weight-bold is-info is-rounded is-fullwidth ${isRequesting && 'is-loading'}`}
                onClick={() => onSubmit(formData)}
                disabled={!isAllValid() || isRequesting}
              >
                設定を変更する
              </button>
              <div style={{ padding: "0px 5px" }}></div>
              <Link
                to={to || '/home'}
                className="button is-text is-rounded is-fullwidth is-outlined"
              >
                {to ? '前の画面' : 'ホーム'}に戻る
              </Link>
            </div>
          ) : (
            <div className="has-text-centered">
              <button
                className={`button is-info is-fullwidth is-rounded ${isRequesting && 'is-loading'}`}
                onClick={() => onSubmit(formData)}
                disabled={!isAllValid() || isRequesting}
              >
                登録して次に進む (2/2)
              </button>
              <p style={{paddingTop: '5px'}} className="is-size-7 has-text-grey">登録した情報は後からでも確認・変更できます</p>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default Main;